export const PRODUCT_COUNTDOWN_INITIAL_TENTHS = 359999
export const PRODUCT_COUNTDOWN_INTERVAL_MS = 100
const TENTHS_PER_SECOND = 10
const TENTHS_PER_MINUTE = 60 * TENTHS_PER_SECOND
const TENTHS_PER_HOUR = 60 * TENTHS_PER_MINUTE

export const formatProductCountdownText = (totalTenths: number): string => {
  const safeTenths = Math.max(0, Math.floor(totalTenths))
  const hours = Math.floor(safeTenths / TENTHS_PER_HOUR)
  const remainder = safeTenths % TENTHS_PER_HOUR
  const minutes = Math.floor(remainder / TENTHS_PER_MINUTE)
  const seconds = Math.floor((remainder % TENTHS_PER_MINUTE) / TENTHS_PER_SECOND)
  const tenths = remainder % TENTHS_PER_SECOND

  const hh = String(hours).padStart(2, '0')
  const mm = String(minutes).padStart(2, '0')
  const ss = String(seconds).padStart(2, '0')

  return `${hh}:${mm}:${ss}.${tenths}`
}
